import { produce } from "immer";

import { userTypes as types } from "../actions";
import { EducatorUserStateType } from "../../../utils";

const defaultState: EducatorUserStateType = {
  users: [],
  usersByRole: [],
  user: null,
  loading: false,
  loaded: false,
  userRatings: null,
  userPoints: null,
  userStatistics: [],
};

const handleSetUser = (state: any, payload: any) => {
  state.user = payload.user;
  return state;
};

const handleSetUserRatings = (state: any, payload: any) => {
  state.userRatings = payload.userRatings;
  state.loading = false;
  return state;
};

const handleSetUserPoints = (state: any, payload: any) => {
  state.userPoints = payload.userPoints;
  state.loading = false;
  return state;
};

const handleSetUserDetailsStatistics = (state: any, payload: any) => {
  state.userStatistics = payload.userStatistics;
  state.loading = false;
  return state;
};

const handleSetUsers = (state: any, payload: any) => {
  state.users = payload.users;
  state.loaded = true;
  state.loading = false;
  return state;
};

const handleSetUsersByRole = (state: any, payload: any) => {
  state.usersByRole = payload.users;
  state.loaded = true;
  state.loading = false;
  return state;
};

const handleDeleteUser = (state: any, id: any) => {
  state.users = state.users.filter((user: any) => user.id !== id);
  state.usersByRole = state.usersByRole.filter((user: any) => user.id !== id);
  return state;
};

export default produce(
  (state: EducatorUserStateType = defaultState, action) => {
    switch (action.type) {
      case types.SET_USER:
        return handleSetUsers(state, action.payload);
      case types.SET_USER_BY_ID:
        return handleSetUser(state, action.payload);
      case types.SET_USER_RATINGS_BY_ID:
        return handleSetUserRatings(state, action.payload);
      case types.SET_USER_POINTS:
        return handleSetUserPoints(state, action.payload);
      case types.SET_USER_DETAILS_STATISTICS:
        return handleSetUserDetailsStatistics(state, action.payload);
      case types.SET_DELETE_USER:
        return handleDeleteUser(state, action.id);
      case types.SET_USER_BY_ROLE:
        return handleSetUsersByRole(state, action.payload);
      case types.GET_USER:
        return {
          ...state,
          loading: true,
        };
      case types.GET_USER_BY_ROLE:
        return {
          ...state,
          loading: true,
        };
      case types.GET_USER_RATINGS_BY_ID:
        return {
          ...state,
          loading: true,
        };
      case types.GET_USER_POINTS:
        return {
          ...state,
          loading: true,
        };
      case types.GET_USER_DETAILS_STATISTICS:
        return {
          ...state,
          loading: true,
        };
      default:
        return state;
    }
  }
);
